import { UserX } from "lucide-react";
import AdminLayout from "@/components/admin/AdminLayout";
import { useTranslation } from "react-i18next";

export default function AccountDeletions() {
  const { t } = useTranslation("admin");
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <UserX size={24} className="text-secondary" />
          <div>
            <h1 className="font-display text-2xl font-bold text-foreground">Suppressions de comptes</h1>
            <p className="text-sm text-muted-foreground mt-1">Gérez les demandes de suppression de comptes utilisateurs.</p>
          </div>
        </div>
        <div className="rounded-xl border border-border bg-card p-8 text-center">
          <p className="text-muted-foreground">{t("placeholder.coming_soon_description")}</p>
        </div>
      </div>
    </AdminLayout>
  );
}
